import React from "react";
import classNames from "classnames";
import { changeLocale, useIntl } from "gatsby-plugin-intl";

const LanguageSwitch = () => {
  const { locale } = useIntl();

  const toggleLanguage = e => {
    localStorage.setItem("visited", "visited");
    changeLocale(e.target.checked ? "fr" : "ar");
  };

  return (
    <div className="flex items-center justify-center w-full">
      <label
        htmlFor="toogleA"
        className="flex items-center cursor-pointer"
        dir="ltr"
      >
        <div
          className={classNames(
            "mr-3 text-white-700 font-medium",
            locale === "ar" && "text-primary font-bold"
          )}
        >
          ع
        </div>
        <div className="relative flex items-center">
          <input
            id="toogleA"
            type="checkbox"
            className="hidden"
            onChange={e => toggleLanguage(e)}
            checked={locale === "fr"}
          />
          <div className="toggle__line w-10 h-6 p-2 bg-white-400 rounded-full shadow-inner" />
          <div className="toggle__dot absolute w-5 h-5 bg-white rounded-full shadow" />
        </div>
        <div
          className={classNames(
            "ml-3 text-white-700 font-medium",
            locale === "fr" && "text-primary font-bold"
          )}
        >
          FR
        </div>
      </label>
    </div>
  );
};

export default LanguageSwitch;
